import { copyFor } from 'config';

const getErrorCopy = copyFor('errors.server');

const serverErrors = [
  {
    copy: getErrorCopy('emailNotFound'),
    message: 'Email address not found',
  },
  {
    copy: getErrorCopy('emailEmpty'),
    message: 'param is missing or the value is empty: email',
  },
  {
    copy: getErrorCopy('firstNameBlank'),
    message: "First name can't be blank",
  },
  {
    copy: getErrorCopy('lastNameBlank'),
    message: "Last name can't be blank",
  },
  {
    copy: getErrorCopy('emailDuplicate'),
    message: 'Email is already taken',
  },
  {
    copy: getErrorCopy('phoneNumberLength'),
    message: 'Phone is the wrong length (should be 10 characters)',
  },
  {
    copy: getErrorCopy('zipCodeInvalid'),
    message: 'Cannot return null for non-nullable field Query.zipCode.',
  },
  {
    copy: getErrorCopy('passwordInvalid'),
    message: 'Password is too short (minimum is 8 characters)',
  },
  {
    copy: getErrorCopy('paymentMethodDuplicate'),
    message: 'Credit card already exists in our records.',
  },
  {
    copy: getErrorCopy('invalidAddress'),
    message:
      'Invalid address. Make sure your address is in the format Street, City, State',
  },
  {
    copy: getErrorCopy('missingCivicData'),
    message: 'We are missing representative data for this address',
  },
  {
    copy: getErrorCopy('deletingActivePaymentMethod'),
    message: 'This payment method is associated with an active account.',
  },
];

export const getServerError = (message: string) => {
  const error = serverErrors.find(serverError =>
    message.includes(serverError.message)
  );
  return error?.copy || getErrorCopy('generic');
};
